<template>
  <router-link v-if="show"
               class="back-to-activity-index-btn"
               :class="[
                  `back-to-activity-index-btn--${targetType}`,
                  { 'in-pc': isPC, }
               ]"
               to="https://m.youthmba.com/marketing/common/activity/springCourse2021"
               v-ym-report:[reportKey]=""
  >
    <template v-if="status === 'birthday'">
      回到「七周年庆钜惠活动」首页
    </template>
    <template v-else>
      回到活动首页
    </template>
  </router-link>
</template>

<script>
  import { isPC } from '@/utils';

  export default {
    name: 'BackToActivityIndexBtn',
    props: {
      targetType: {
        type: String,
        required: true,
      },
      show: {
        type: Boolean,
        default: true,
      },
      status: {
        type: String,
        default: 'birthday',
      },
    },
    computed: {
      reportKey() {
        if (this.targetType === 'combo') return 'ANNIVERSARY_2020_BRANCH_THEME_PACK_BACK_CLICK';
        if (this.targetType === 'course') return 'ANNIVERSARY_2020_BRANCH_LIVE_BACK_CLICK';
        return 'ANNIVERSARY_2020_BRANCH_ENTITY_BACK_CLICK';
      },
    },
    data() {
      return {
        isPC: isPC(),
      };
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .back-to-activity-index-btn {
    position: fixed;
    left: 50%;
    bottom: @size-base;
    width: 630px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: @font-size-large;

    font-weight: @font-weight-bold;
    border-radius: 50px;
    transform: translate3d(-50%, 0, 0);

    &--combo {
      color: #7c382c;
      background: linear-gradient(0deg, #ffd996, #ffcf72, #ffe7b8);
    }

    &--course {
      color: #336580;
      background: #d9fcff;
    }

    &--entity {
      color: @color-white;
      background: #008D94;
    }

    &.in-pc {
      width: 630PX;
      height: 80PX;
      font-size: 36PX;
    }
  }

</style>
